import { CookieStorage } from "cookie-storage";
import { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import { get } from "../../../api";
import { getCurrentQueryObject } from "../../../tools/func";
import {getItem, useLocalStorageState} from "../../../tools/storage";
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}

export default function SponsorName() {
  const mlm_show_referred_by = useSelector(
    (state) => state.settings.mlm_show_referred_by
  );
  const [name, setName] = useState(null);
  const ref = useLocalStorageState(
    (state) =>
      state.ref || getCurrentQueryObject()?.ref || getItem("ref")
  );
  useEffect(() => {
    if (ref) {
      const abortController = new AbortController();
      get("/who_is_the_referrer", { ref }, abortController)
        .then(({ name }) => {
          setName(name);
        })
        .catch((e) => {});
      return () => {
        abortController.abort();
      };
    } else {
      setName(null);
    }
  }, [ref]);
  if (!mlm_show_referred_by) {
    return null;
  }
  if (!name) return null;
  return (
    <div className={"text-muted ml-4"}>
      <small>
        <FormattedMessage id="Referred by" />
      </small>
      <div>{name}</div>
    </div>
  );
}
